import { useAuthContext } from '../context/AuthContext';

/** Access the authenticated user and auth actions (sign in / sign up / sign out / reset). */
export function useAuth() {
  return useAuthContext();
}
